export enum FindCookStatus {
  PENDING = "PENDING",
  INITIATED = "INITIATED",
  DETAILS_SHARED = "FOUND_COOK_DETAILS_SHARED",
  OTHER_ALLOCATED = "FOUND_COOK_OTHER_ALLOCATED",
  SAME_ALLOCATED = "FOUND_COOK_SAME_ALLOCATED",
  COOK_NOT_FOUND = "COULD_NOT_FIND_COOK",
}
